import Image from "next/image";

import theme from "@/styles/scss/theme.module.scss";
import styles from "./FlowSpinner.module.scss";

interface FlowSpinnerProps {
  height: number;
  width: number;
  color?: string;
}

function FlowSpinner({ height, width, color }: FlowSpinnerProps) {
  return (
    <div
      className={styles.spinner}
      style={{ height, width }}
    >
      <svg
        viewBox="0 0 420 420"
        xmlns="http://www.w3.org/2000/svg"
        style={{ height, width }}
      >
        <circle
          className={styles.spin}
          cx="210"
          cy="210"
          fill="none"
          r="200"
          strokeWidth="10"
          stroke={color === "secondary" ? theme.secondaryMain : theme.primaryMain}
          strokeDasharray="938 1400"
          strokeLinecap="round"
        />
      </svg>
      <Image
        src={color === "secondary" ? "/image/icon_wave_large_light.svg" : "/image/icon_wave_large.svg"}
        alt="Flow Spinner"
        width={width * 0.6}
        height={height * 0.6}
      />
    </div>
  );
}

export default FlowSpinner;
